import React, { useEffect, useState } from 'react';
import TopCrumb from '../components/TopCrumb';
import questionApi from '../services/questionActions';
import { message } from 'antd';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import ReactPlayer from 'react-player/lazy';

const Video = () => {
  const [searchParams] = useSearchParams();
  const curModule = searchParams.get('module');
  const { module } = useSelector((state) => state.user);
  const [urlString, setUrlString] = useState('');
  const [isCompleted, setIsCompleted] = useState(false);

  useEffect(() => {
    if (module) {
      setUrlString(module.vimeo_link);
    }
  }, [module, curModule]);

  const onVideoComplete = () => {
    if (isCompleted) return; // prevent multiple triggers
    setIsCompleted(true);

    let data = {
      course_id: module?.id,
      type: 'video',
    };

    const courseStatusUpdateVideo = async () => {
      try {
        const videoData = await questionApi.courseStatusAction(data);

        message.success('Video Completed');
        if (videoData) {
          if (Number(curModule) > 0) {
            setTimeout(() => {
              window.location.href = `/assessment?module=${curModule}`;
            }, 2000);
          }
        }
      } catch (error) {
        if (error.response?.data.error) {
          message.error(error.response?.data.error);
        }
      }
    };

    courseStatusUpdateVideo();
  };

  const handleProgress = (state) => {
    const played = state.played;
    if (played >= 0.995 && !isCompleted) {
      return onVideoComplete();
    }
  };

  return (
    <div className="container">
      <div className="mt-4">
        <TopCrumb module={module} type="Video" />

        <div className="video-container mt-4 ">
          <div className="video-wrapper">
            <ReactPlayer
              controls={true}
              url={urlString}
              width="100%"
              height={'100%'}
              onEnded={onVideoComplete}
              onProgress={handleProgress}
              config={{ file: { attributes: { controlsList: 'nodownload' } } }}
              onContextMenu={(e) => e.preventDefault()}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Video;
